import { gql } from 'graphql-tag';

const countryId = gql`
  fragment CountryId on Country {
    id
  }
`;

const countryDetailFields = gql`
  fragment CountryDetailFields on Country {
    ...CountryId
    countryName
  }
  ${countryId}
`;

const fishingWaterCountryFields = gql`
  fragment FishingWaterCountryFields on Country {
    ...CountryId
    countryName
    topFishingWaters(first: 20) {
      edges {
        node {
          _id: externalId
          displayName
        }
      }
    }
    topSpecies(first: 20) {
      edges {
        node {
          _id: externalId
          displayName
        }
      }
    }
  }
  ${countryId}
`;

const placeCountryFields = gql`
  fragment PlaceCountryFields on Country {
    ...CountryId
    countryName
    topFishingWaters(first: 20) {
      edges {
        node {
          _id: externalId
          displayName
        }
      }
    }
    topSpecies(first: 20) {
      edges {
        node {
          _id: externalId
          displayName
        }
      }
    }
  }
  ${countryId}
`;

const regionCountryFields = gql`
  fragment RegionCountryFields on Country {
    ...CountryId
    countryName
    topFishingWaters(first: 20) {
      edges {
        node {
          _id: externalId
          displayName
        }
      }
    }
  }
  ${countryId}
`;

export const CountryFragments = {
  id: countryId,
  detailFields: countryDetailFields,
  fishingWaterCountryFields,
  placeCountryFields,
  regionCountryFields,
};
